"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showAddress = void 0;
const addressParams_1 = require("./serialization/addressParams");
const deriveAddress_1 = require("./deriveAddress");
const send = (params) => (Object.assign({ ins: 17 }, params));
function* showAddress(version, addressParams) {
    (0, deriveAddress_1.ensureAddressDerivationSupportedByAppVersion)(version, addressParams);
    const P1_DISPLAY = 0x02;
    const P2_UNUSED = 0x00;
    yield send({
        p1: P1_DISPLAY,
        p2: P2_UNUSED,
        data: (0, addressParams_1.serializeAddressParams)(addressParams, version),
        expectedResponseLength: 0,
    });
}
exports.showAddress = showAddress;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2hvd0FkZHJlc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW50ZXJhY3Rpb25zL3Nob3dBZGRyZXNzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUdBLGlFQUFvRTtBQUNwRSxtREFBNEU7QUFFNUUsTUFBTSxJQUFJLEdBQUcsQ0FBQyxNQUtiLEVBQWMsRUFBRSxDQUFDLGlCQUFFLEdBQUcsUUFBeUIsTUFBTSxFQUFFLENBQUE7QUFFeEQsUUFBZSxDQUFDLENBQUMsV0FBVyxDQUMxQixPQUFnQixFQUNoQixhQUFrQztJQUVsQyxJQUFBLDREQUE0QyxFQUFDLE9BQU8sRUFBRSxhQUFhLENBQUMsQ0FBQTtJQUVwRSxNQUFNLFVBQVUsR0FBRyxJQUFJLENBQUE7SUFDdkIsTUFBTSxTQUFTLEdBQUcsSUFBSSxDQUFBO0lBRXRCLE1BQU0sSUFBSSxDQUFDO1FBQ1QsRUFBRSxFQUFFLFVBQVU7UUFDZCxFQUFFLEVBQUUsU0FBUztRQUNiLElBQUksRUFBRSxJQUFBLHNDQUFzQixFQUFDLGFBQWEsRUFBRSxPQUFPLENBQUM7UUFDcEQsc0JBQXNCLEVBQUUsQ0FBQztLQUMxQixDQUFDLENBQUE7QUFDSixDQUFDO0FBZkQsa0NBZUMifQ==